export default __webpack_public_path__ + "static/media/Multiple-answers-to-a-question.dbe05fb5.svg";